import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import LinePlaneFlyIcon from 'LuxKit/Icons/line/LinePlaneFlyIcon'
import CaptionTextBlock from 'LuxKit/TextBlocks/CaptionTextBlock'
import Group from 'components/utils/Group'
import type { PropsWithChildren, ReactNode } from 'react'
import * as React from 'react'
import { defineMessages, useIntl } from 'react-intl'
import type { MessageDescriptor } from 'react-intl'

export const ACCOMMODATION_PACKAGE_TITLE = {
  HOTEL: 'hotel',
  HOTEL_AND_FLIGHTS: 'hotel-and-flights',
} as const

type AccommodationPackageTitleType = typeof ACCOMMODATION_PACKAGE_TITLE[keyof typeof ACCOMMODATION_PACKAGE_TITLE]

const titleMessages: Record<AccommodationPackageTitleType, MessageDescriptor> = defineMessages({
  'hotel': {
    id: 'JZ3-s1_WRvpPKN5mTma9',
    defaultMessage: 'Hotel',
    description: 'Title label shown above the package price for hotel-only packages.',
  },
  'hotel-and-flights': {
    id: 'Us6SJTbOPnAQcYJmNn5S',
    defaultMessage: 'Hotel + flights',
    description: 'Title label shown above the package price for hotel and flights packages.',
  },
})

interface Props extends Utils.PropsWithDataAttributes, Omit<React.ComponentProps<typeof Group>, 'direction' | 'verticalAlign' | 'gap'> {
  callToAction?: ReactNode
  title: AccommodationPackageTitleType | undefined
}

function AccommodationPackageTilePricingBlock(props: PropsWithChildren<Props>) {
  const {
    callToAction,
    children,
    title,
    ...rest
  } = props

  const intl = useIntl()

  const titleText = title ? intl.formatMessage(titleMessages[title]) : undefined

  return <Group
    {...rest}
    direction="vertical"
    verticalAlign="space-between"
    gap={20}
  >
    <VerticalSpacer gap={8}>
      {title && <CaptionTextBlock
        variant="large"
        weight="bold"
        startIcon={title === 'hotel-and-flights' && <LinePlaneFlyIcon />}
      >
        {titleText}
      </CaptionTextBlock>}
      {children && <div>{children}</div>}
    </VerticalSpacer>

    {callToAction}
  </Group>
}

export default AccommodationPackageTilePricingBlock
